var _path, _g, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFileTypeZip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 40,
    viewBox: "0 0 32 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.49998 0H19.7412L30.9999 11.215V37.5C30.9999 38.8812 29.88 40 28.4999 40H2.49998C1.11994 40 0 38.8812 0 37.5V2.49998C0 1.11877 1.12007 0 2.49998 0Z",
    fill: "#F4B459"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2137_45150)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9638 11.2504H22.25C20.8699 11.2504 19.75 10.1305 19.75 8.75041V0.0253906L30.9638 11.2504Z",
    fill: "#F4CF9A"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.78914 24C8.58914 24 8.42581 23.96 8.29914 23.88C8.17247 23.7933 8.08581 23.68 8.03914 23.54C7.99914 23.3933 7.99914 23.2333 8.03914 23.06C8.08581 22.8867 8.17914 22.7133 8.31914 22.54L11.9591 17.77V18.24H8.66914C8.44914 18.24 8.27914 18.1833 8.15914 18.07C8.04581 17.9567 7.98914 17.7967 7.98914 17.59C7.98914 17.3833 8.04581 17.2267 8.15914 17.12C8.27914 17.0067 8.44914 16.95 8.66914 16.95H12.6891C12.8958 16.95 13.0591 16.9933 13.1791 17.08C13.3058 17.16 13.3925 17.27 13.4391 17.41C13.4858 17.55 13.4858 17.71 13.4391 17.89C13.3925 18.0633 13.2991 18.2367 13.1591 18.41L9.51914 23.17V22.71H12.9691C13.1891 22.71 13.3558 22.7667 13.4691 22.88C13.5891 22.9867 13.6491 23.1433 13.6491 23.35C13.6491 23.5633 13.5891 23.7267 13.4691 23.84C13.3558 23.9467 13.1891 24 12.9691 24H8.78914ZM15.2615 24.09C15.0082 24.09 14.8148 24.02 14.6815 23.88C14.5482 23.74 14.4815 23.5433 14.4815 23.29V17.66C14.4815 17.4067 14.5482 17.21 14.6815 17.07C14.8148 16.93 15.0082 16.86 15.2615 16.86C15.5082 16.86 15.6982 16.93 15.8315 17.07C15.9648 17.21 16.0315 17.4067 16.0315 17.66V23.29C16.0315 23.5433 15.9648 23.74 15.8315 23.88C15.7048 24.02 15.5148 24.09 15.2615 24.09ZM18.2302 24.09C17.9769 24.09 17.7836 24.02 17.6502 23.88C17.5169 23.74 17.4502 23.5433 17.4502 23.29V17.74C17.4502 17.48 17.5169 17.2833 17.6502 17.15C17.7902 17.0167 17.9869 16.95 18.2402 16.95H20.6702C21.4569 16.95 22.0636 17.15 22.4902 17.55C22.9169 17.9433 23.1302 18.4933 23.1302 19.2C23.1302 19.9067 22.9169 20.46 22.4902 20.86C22.0636 21.26 21.4569 21.46 20.6702 21.46H19.0002V23.29C19.0002 23.5433 18.9336 23.74 18.8002 23.88C18.6736 24.02 18.4836 24.09 18.2302 24.09ZM19.0002 20.26H20.4102C20.8102 20.26 21.1136 20.17 21.3202 19.99C21.5336 19.81 21.6402 19.5467 21.6402 19.2C21.6402 18.8533 21.5336 18.5933 21.3202 18.42C21.1136 18.2467 20.8102 18.16 20.4102 18.16H19.0002V20.26Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2137_45150",
    x: 18.75,
    y: 0.0253906,
    width: 13.2139,
    height: 13.2246,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.5 0 0 0 0 0.368852 0 0 0 0 0.182377 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2137_45150"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2137_45150",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFileTypeZip);
export default __webpack_public_path__ + "static/media/ic_file_type_zip.f092f7aa6f7573665798b6ca7f1b430c.svg";
export { ForwardRef as ReactComponent };